import Positions from '../../../../../store/billing/positions';

class InfoDocumentModalController {
    constructor($injector, $uibModalInstance, $scope, invoice) {
        this.modalInstance = $uibModalInstance;
        this.scope = $scope;
        this.invoice = invoice;
        this.injector = $injector;
        this.invoice = invoice;
        this.api = this.injector.get('$http');
        this.alert = this.injector.get('Alert');
        this.userStore = this.injector.get('Users');

        this.runningInfoDocExports = [];
        this.doneInfoDocExports = [];
        this.printEnabled = _.get(this.userStore.state.company, 'settings.billing.info_document_popup_print_enabled', false);
    }

    close() {
        this.modalInstance.close();
    }

    cancel() {
        this.modalInstance.close();
    }

    printInfoDocumentForRsvp(rsvp) {
        this.runningInfoDocExports.push(rsvp.id)
        this.api.post(`exports/rsvps/${rsvp.id}/info-doc`, {})
            .then((response) => {
                this.alert.success('Print started', 'The info document print was started');
                this.runningInfoDocExports.splice(this.runningInfoDocExports.indexOf(rsvp.id), 1);
                this.doneInfoDocExports.push(rsvp.id)
            }, (response) => {
                this.alert.error('Print Error', 'There was an error while print the info doc');
                this.runningInfoDocExports.splice(this.runningInfoDocExports.indexOf(rsvp.id), 1);
            });
    }
}

InfoDocumentModalController.$inject = [
    '$injector',
    '$uibModalInstance',
    '$scope',
    'invoice'
];

/**
 * @ngdoc object
 * @name billing.invoices.controller:BillingSelectPositionController
 *
 * @description
 *
 */
angular
    .module('festzelt-os.billing.invoices')
    .controller('BillingInfoDocumentModalController', InfoDocumentModalController);



// WEBPACK FOOTER //
// ./src/app/pages/billing/invoices/controllers/modals/info-document-modal-controller.js